import React from 'react'
import PaymentTermDetailsContent from '../../../components/Dashboard/PaymentTermsListContent/View';
import { Link } from 'react-router-dom';

function PaymentTermDetails() {
    return (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-card">
            <h5>Payment Term Details</h5>
    
            <ul className="breadcrumb">
              <li>
                <Link to="/dashboard/ecommerce/">
                  <i className="material-symbols-outlined">home</i>
                  Dashboard
                </Link>
              </li>
              <li>
              <Link to="/payment-terms">
                  Payment Terms
                </Link>
              </li>
              <li>Payment Terms Details</li>
            </ul>
          </div> */}
           
          <PaymentTermDetailsContent />
        </>
      );
}

export default PaymentTermDetails
